module.exports = __webpack_public_path__ + "static/media/welcome.d422d1e0.jpg";